import * as React from 'react'
import * as _ from 'lodash'
import cn from 'classnames'
import htmlParser from 'html-react-parser'
import { Col, Row } from 'antd'
import { Link } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import { AsideBlock, getTableContentTree, HistoryBlock } from 'Pages/knowledge'
import { sanitizeHtml } from 'Helpers'
import { TagModel } from 'Pages/admin'
import { Indent, Text, TextType } from 'LibNeo'
import { UpdatingHistory } from 'Pages/knowledge/articles/components/UpdatingHistory'
import { Icon } from './styled'

interface ComponentProps {
	article: any
}

interface ComponentState {
	isFixedTableContent?: boolean
}

class ArticleView extends React.PureComponent<ComponentProps & InjectedIntlProps, ComponentState> {
	public constructor(props: ComponentProps & InjectedIntlProps) {
		super(props)
		this.state = {
			isFixedTableContent: false,
		}
	}

	public componentDidMount(): void {
		window.addEventListener('wheel', this.scrollPage)
		window.addEventListener('scroll', this.scrollPage)
	}

	public componentWillUnmount(): void {
		window.removeEventListener('wheel', this.scrollPage)
		window.removeEventListener('scroll', this.scrollPage)
	}

	private pagePrefix = 'knowledge'
	private prefix = 'knowledge-article-view'
	private articleView = null

	private scrollPage = (): void => {
		const rectArticle = this.articleView.getBoundingClientRect()

		if (rectArticle.top < 35) {
			this.setState({ isFixedTableContent: true })
		}
		if (rectArticle.top > -53) {
			this.setState({ isFixedTableContent: false })
		}
	}
	private parseTableOfContentElement = (elements: any): any => {
		return (
			<ol className={`${this.prefix}__table-list`}>
				{elements.map((element): JSX.Element => {
					const linkClass = cn(`${this.prefix}__table-list-link`, {
						[`${this.prefix}__table-list-link--bold`]: !element.parent,
					})
					return (
						<li className={`${this.prefix}__table-list-item`} key={element.url}>
							<a href={element.url} className={linkClass}>
								{element.title}
							</a>
							{element.childrens && element.childrens.length
								? this.parseTableOfContentElement(element.childrens)
								: null}
						</li>
					)
				})}
			</ol>
		)
	}

	public render(): JSX.Element {
		const { prefix, pagePrefix } = this
		const { isFixedTableContent } = this.state

		const { article } = this.props
		const { editable_by_current_user } = article
		const name = _.get(article, 'name', null)
		const html = _.get(article, 'html', '')
		const table_of_contents = _.get(article, 'table_of_contents', true)
		const idProject = _.get(article, 'project.id', null)
		const idArticle = _.get(article, 'id', null)
		const tags = _.get(article, 'tags', [])
		const { article: htmlText, table_of_content } = getTableContentTree(sanitizeHtml(html))
		const reverseComments = article?.comments?.slice().reverse()

		return (
			<div
				className={`${prefix}__wrapper`}
				ref={(node): void => {
					this.articleView = node
				}}
			>
				<Row>
					<h1 className={`${pagePrefix}__h1`}>
						{name}
						{editable_by_current_user && (
							<Icon
								name="edit-outline"
								link={FrontUrls.knowledge.article_edit
									.replace(':idProject', idProject.toString())
									.replace(':id', idArticle.toString())}
							/>
						)}
					</h1>
					{tags.length > 0 && (
						<div className={`${this.prefix}__tags`}>
							<span className={`${this.prefix}__tags-title`}>
								<FormattedMessage id={`${pagePrefix}.tags_title`} />:
							</span>
							{tags.map((item: TagModel): any => (
								<Link
									to={`${FrontUrls.knowledge.article_search}?query=${item.name}`}
									className={`${this.prefix}__tag`}
									key={`${this.prefix}_${item.slug}`}
								>
									{item.name}
								</Link>
							))}
						</div>
					)}
				</Row>
				<Row>
					<Col xs={24} lg={16} xl={18}>
						{htmlText ? (
							<div className={`${prefix}__content`}>{htmlParser(htmlText)}</div>
						) : (
							<div className={`${prefix}__content`}>
								<FormattedMessage id={`${pagePrefix}.article_view_no_html`} />
							</div>
						)}
					</Col>
					<Col offset={1} xs={0} lg={7} xl={5}>
						<AsideBlock isFixedTableContent={isFixedTableContent}>
							{table_of_contents && (
								<div className={`${prefix}__table-of-content`}>
									<p className={`${this.prefix}__table-list-header`}>Содержание</p>
									{this.parseTableOfContentElement(table_of_content)}
								</div>
							)}

							{Boolean(reverseComments.length) && (
								<HistoryBlock>
									<Text type={TextType.BODY2} colorIndex={6}>
										История изменений
									</Text>
									<Indent top={12}>
										{reverseComments?.map((item, index) => (
											<UpdatingHistory
												comment={item.comment}
												date={item.created_at}
												lastEvent={index === reverseComments?.length - 1}
											/>
										))}
									</Indent>
								</HistoryBlock>
							)}
						</AsideBlock>
					</Col>
				</Row>
			</div>
		)
	}
}

export const ArticleViewComponent = injectIntl(ArticleView)
